<div class="policy-category custom-permit">

  <div class="policy-item">
    <i class="policy-number">1</i>
    <div class="default-text large"><strong>Custom permits</strong></div>
    <div class="default-text" [innerHTML]="textCopy.subtitle"></div>

    <span class="select-layer inline">
      <select class="app-select"
              (change)="onCustomPermitChange($event.target.value)"
              [disabled]="isCustomPermitsLoading">
        <option value="0" selected disabled hidden>please select...</option>
        <option value="1" style="font-weight: bold;">new custom permit</option>
        <option [value]="customPermit.id" *ngFor="let customPermit of customPermits">
          {{customPermit.singularName}}
        </option>
      </select>
    </span>
    <span (click)="deleteCustomPermit()" class="custom-permit-button"
       [ngClass]="{'disabled': !isCustomPermitSelected()}">
      delete
  </span>

    <div class="label info" [ngClass]="customPermitDeleteSuccess ? 'green' : 'red'"
       *ngIf="customPermitDeleteMessage.length > 0" style="float: none;">
      {{customPermitDeleteMessage}}
    </div>

    <div class="default-text" [innerHTML]="textCopy.changeNameTitle"></div>
    <div class="default-text" [innerHTML]="textCopy.singularExText"></div>
    <input aria-label=""  class="app-input" type="text" [(ngModel)]="selectedCustomPermit.singularName"
           [disabled]="selectedCustomPermit.id === '0'" />
    <div class="label info red" *ngIf="singularNameError.length > 0">
      {{singularNameError}}
    </div>

    <div class="default-text" [innerHTML]="textCopy.pluralExText"></div>
    <input aria-label=""  class="app-input" type="text" [(ngModel)]="selectedCustomPermit.pluralName"
           [disabled]="selectedCustomPermit.id === '0'" />
    <div class="label info red" *ngIf="pluralNameError.length > 0">
      {{pluralNameError}}
    </div>

    <br />
    <radio-question [data]="displayedWithClock.data" 
                    [active]="selectedCustomPermit.id !== '0'"
                    [valueSelected]="selectedCustomPermit.clock"
                    (selectAnswer)="onDisplayedWithClockSelected($event)"></radio-question>

    <div class="default-text" [innerHTML]="textCopy.hintText"></div>
    <span class="select-layer inline" [ngClass]="{'disabled': selectedCustomPermit.id === '0'}">
      <select class="app-select" [(ngModel)]="selectedCustomPermit.sourceReasonId"
              [disabled]="selectedCustomPermit.id === '0'">
        <option value="0" selected disabled hidden>please select...</option>
        <option [value]="existingPermit.id" *ngFor="let existingPermit of existingPermits">
          {{existingPermit.text}}
        </option>
      </select>
    </span>
    <!-- <a class="delete-text-inline" *ngIf="getPermitChecklistText().length === 0">
      {{textCopy.hoverText}}
    </a> -->
    <a class="delete-text-inline hover-text active" [ngbPopover]="permitChecklistText"
       triggers="hover" placement="top" *ngIf="getPermitChecklistText().length > 0">
      {{textCopy.hoverText}}
    </a>
    <ng-template #permitChecklistText>
      <div [innerHTML]="getPermitChecklistText() | safe: 'html'"></div>
    </ng-template>
    <div class="label info red" *ngIf="sourceReasonIdError.length > 0">
      {{sourceReasonIdError}}
    </div>

    <br />
    <radio-question [data]="reconsider.data" [active]="selectedCustomPermit.id !== '0'"
                    [valueSelected]="selectedCustomPermit.reconsider"
                    (selectAnswer)="onReconsiderSelected($event)"></radio-question>

    <br />
    <select-question [data]="failDisplay.data" [active]="selectedCustomPermit.id !== '0' && selectedCustomPermit.reconsider !== 'n'"
                     [valueSelected]="selectedCustomPermit.goodwillCancellations"
                     (selectAnswer)="onFailDisplaySelected($event)"></select-question>

    <br />
    <explain-question [data]="explain.data" [active]="selectedCustomPermit.id !== '0'"
                      [valueSelected]="selectedCustomPermit.misuseOption"
                      [validationSelected]="selectedCustomPermit.signpostOption"
                      [validationText]="selectedCustomPermit.myOwnExplanation"
                      (selectAnswer)="onExplainSelected($event)"></explain-question>
  </div>

  <div class="label info red" *ngIf="generalError.length > 0">
    {{generalError}}
  </div>
  <div class="label info" [ngClass]="customPermitSuccess ? 'green' : 'red'"
       *ngIf="customPermitMessage.length > 0">
    {{customPermitMessage}}
  </div>
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" (click)="submitCustomPermit()"
           [value]="selectedCustomPermit.id === '0' || selectedCustomPermit.id === '1' ? 'Add' : 'Update'"
           [disabled]="selectedCustomPermit.id === '0' || selectedCustomPermit.sourceReasonId === '0'" />
  </div>

</div>
